/**
 * API配置文件
 * 所有API相关的配置项都集中在此处管理
 */

// API基础URL - 使用相对路径（会通过devServer代理转发）
export const API_BASE_URL = '';  // 改为空字符串，使用相对路径

// API版本
export const API_VERSION = 'v1';

// 完整的API前缀，包含基础URL和版本
export const API_PREFIX = `${API_BASE_URL}/api/${API_VERSION}`;

// 各模块API路径
export const API_PATHS = {
  // 认证相关
  AUTH: {
    LOGIN: '/auth/login',
    SMS_LOGIN: '/auth/sms-login',
    REFRESH_TOKEN: '/auth/refresh-token',
    LOGOUT: '/auth/logout',
    REGISTER: '/auth/register',
    RESET_PASSWORD: '/auth/reset-password',
    VERIFY_CODE: '/auth/verify-code',
    USER_INFO: '/user/info',
    SEND_SMS: '/public/sms/send'
  },
  
  // 校区相关
  CAMPUS: {
    LIST: '/campus/list',
    DETAIL: '/campus/{id}',
    CREATE: '/campus',
    UPDATE: '/campus/{id}',
    DELETE: '/campus/{id}',
    SELECT: '/campus/select'
  },
  
  // 学生相关
  STUDENT: {
    LIST: '/students',
    DETAIL: '/students/{id}',
    CREATE: '/students',
    UPDATE: '/students/{id}',
    DELETE: '/students/{id}'
  },
  
  // 教师相关
  TEACHER: {
    LIST: '/teachers',
    DETAIL: '/teachers/{id}',
    CREATE: '/teachers',
    UPDATE: '/teachers/{id}',
    DELETE: '/teachers/{id}'
  },
  
  // 通信相关
  COMMUNICATION: {
    TEACHER_CHATS: '/communication/teacher/chats',
    PARENT_CHATS: '/communication/parent/chats',
    MESSAGES: '/communication/messages',
    SEND_MESSAGE: '/communication/messages/send',
    MARK_READ: '/communication/messages/read',
    UPLOAD_ATTACHMENT: '/communication/attachment/upload',
    CONTACTABLE_PARENTS: '/communication/teacher/contactable-parents',
    CREATE_CHAT: '/communication/chat/create'
  },
  
  // 班级相关
  CLASS: {
    LIST: '/classes',
    DETAIL: '/classes/{id}',
    CREATE: '/classes',
    UPDATE: '/classes/{id}',
    DELETE: '/classes/{id}',
    TEACHERS: '/classes/{id}/teachers',
    STUDENTS: '/classes/{id}/students',
    TEACHER_STATUS: '/classes/{id}/teachers/{teacherId}',
    STUDENT_STATUS: '/classes/{id}/students/{studentId}',
    DELETE_TEACHER: '/classes/{id}/teachers/{teacherId}',
    DELETE_STUDENT: '/classes/{id}/students/{studentId}'
  },
  
  // 家长相关
  PARENT: {
    LIST: '/parents',
    DETAIL: '/parents/{id}',
    CREATE: '/parents',
    UPDATE: '/parents/{id}',
    DELETE: '/parents/{id}',
    STUDENTS: '/parents/{id}/students',
    CHILDREN: '/parent/children',
    CHILD_HOMEWORKS: '/parent/child/{student_id}/homeworks'
  },
  
  // 管理员相关
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    STATISTICS: '/admin/statistics'
  },
  
  // 学校相关
  SCHOOL: {
    LIST: '/admin/schools',
    DETAIL: '/admin/schools/{id}',
    CREATE: '/admin/schools',
    UPDATE: '/admin/schools/{id}',
    DELETE: '/admin/schools/{id}'
  },
  
  // 活动相关
  ACTIVITY: {
    LIST: '/activities',
    DETAIL: '/activities/{id}',
    CREATE: '/activities',
    UPDATE: '/activities/{id}',
    DELETE: '/activities/{id}',
    ORGANIZERS: '/activities/{id}/organizers',
    PARTICIPANTS: '/activities/{id}/participants',
    PARTICIPANT: '/activities/{id}/participant'
  },
  
  // 用户相关
  USER: {
    PROFILE: '/user/profile',
    UPDATE_PROFILE: '/user/profile',
    CHANGE_PASSWORD: '/user/change-password'
  }
};

/**
 * 获取完整的API URL
 * @param {string} path - API路径，不包含前缀
 * @returns {string} 完整的API URL
 */
export function getApiUrl(path) {
  return process.env.VUE_APP_API_URL + path;
}

export default {
  API_BASE_URL,
  API_VERSION,
  API_PREFIX,
  API_PATHS,
  getApiUrl
}; 